import CryptoJS from "crypto-js";

const STORAGE_KEY = "emma_cart";
const SECRET_KEY = "emma_cart_secret_v1"; // pode mover para env futuramente

export function saveCart(cart) {
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(cart),
    SECRET_KEY
  ).toString();

  localStorage.setItem(STORAGE_KEY, encrypted);
}

export function loadCart() {
  const encrypted = localStorage.getItem(STORAGE_KEY);
  if (!encrypted) return [];

  try {
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted) || [];
  } catch (err) {
    console.error("Erro ao descriptografar carrinho:", err);
    return [];
  }
}

export function clearCart() {
  localStorage.removeItem(STORAGE_KEY);
}
